
import React from 'react';


import {connect} from 'react-redux';
import html2pdf from 'html2pdf.js';
import LoftyDropdownComponent from '../../components/loftydropdowncomponent';
import LoftyCountDown from '../../components/loftycountdown';
import LoftyCartCarousel from '../../components/loftycartcarousel';
import LoftyThreeCarousel from '../../components/loftythreecarousel';
import LoftyCarouselPlugin from '../../components/LoftyCarouselPlugin';
import LoftyLeaftMap from '../../components/loftyLeaftMaps';
import LoftyEditorJsReadOnly from '../../components/LoftyEditorJsReadOnly';
import LoftyEditorJs from '../../components/LoftyEditorJs';

import { addLoftyToken, deleteLoftytoken } from '../../actions/auth.actions';


import './homepageterapiasenergticas15fz9.scss';


// Hamburger
function loftyInitHam() {
  try {
  // eslint-disable-next-line no-restricted-globals
    window.addEventListener('click', (event) => {
      let originPointLeft = '';
      const comp = event.target.className;
      if (comp.includes('menu__btn') || comp.includes('span_middle') || comp.includes('span_before') || comp.includes('span_after')) {
        const res = Array.from(document.getElementsByClassName('menu__box'));
        const spanData = Array.from(document.getElementsByClassName('menu__btn'));
        const closeBtn = Array.from(document.getElementsByClassName('menu__close__btn'));
        spanData.forEach((item) => {
          originPointLeft = item.style.left;
        });
        res.forEach((item) => {
          item.style.left = '0px';
        });
        spanData.forEach((item) => {
          item.style.left = '-300px';
        });
        closeBtn.forEach((item) => {
          item.style.left = '10px';
        });
      } else {
        if (comp === 'menu__box') {
          return;
        }
        if (comp === 'linkshref') {
          return;
        }
        if (comp === 'menu__item') {
          return;
        }
        const res = Array.from(document.getElementsByClassName('menu__box'));
        const spanData = Array.from(document.getElementsByClassName('menu__btn'));
        const closeBtn = Array.from(document.getElementsByClassName('menu__close__btn'));
        res.forEach((item) => {
          item.style.left = '-300px';
        });
        spanData.forEach((item) => {
          item.style.left = originPointLeft;
        });
        closeBtn.forEach((item) => {
          item.style.left = '-100%';
        });
      }
    });
  } catch (error) {
    // console.log(error);
  }
}    
    




const Phomepageterapiasenergticas15fz9 = ({
  match,
  history,
  loftytoken,
  loftyuser,
  addLoftyUserApp,
  deleteLoftytokenApp,
  addLoftyTokenApp,
  
}) => {





  
  setTimeout(() => { loftyInitHam(); }, 2000);

  
  

  
  return (
    <div id="id6765becf1de4874021c1ebe5" >

      <div id="iw4j" className="">
      
      <div id="ips2" className="">
      
      <div id="icq3pj" className="">
      
      <div id="" className="contentwrapperanimated ">
      
      <div id="" className="container_animated ">
      
      <label id="" className="menu__btn ">
      
      <span className="span_before " id="">
        
      </span>
      
      <span className="span_middle " id="">
        
      </span>
      
      <span className="span_after " id="">
        
      </span>
      
      </label>
      
      <label id="" className="menu__close__btn ">
      
      <span className="span__close__left " id="">
        
      </span>
      
      <span className="span__close__right " id="">
        
      </span>
      
      </label>
      
      <ul id="" className="menu__box ">
        
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/"
        type=""
      >
        <>INICIO</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/servicios"
        type=""
      >
        <>SERVICIOS</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/articulos"
        type=""
      >
        <>ARTICULOS</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/contactanos"
        type=""
      >
        <>CONTÁCTANOS</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      </li>
      
      </ul>
      
      </div>
      
      </div>
      
      </div>
      
      <img
        className=""
        id="ing4c9"
        src="https://assetsprojects.s3.amazonaws.com/404ofwim5mu70g5.png"
        alt="undefined"
      />
      
      <div id="i1prlw" className="">
      
      <div id="itmdc" className="">
      
      <a
        target=""
        className=""
        id="i2aqf"
        href="/"
        type="button"
      >
        
    <div id="i2g1w" className="">
    <>INICIO</>
    </div>
    
      </a>
      
      <a
        target=""
        className=""
        id="iwu1w"
        href="/servicios"
        type="button"
      >
        
    <div id="ib1qi" className="">
    <>SERVICIOS</>
    </div>
    
      </a>
      
      <a
        target=""
        className=""
        id="i31ek"
        href="/blog"
        type="button"
      >
        
    <div id="ipu5h" className="">
    <>ARTICULOS</>
    </div>
    
      </a>
      
      <a
        target=""
        className=""
        id="ig1at"
        href="/contactanos"
        type="button"
      >
        
    <div id="isq53" className="">
    <>CONTÁCTANOS</>
    </div>
    
      </a>
      
      </div>
      
      <div id="iacot" className="">
      
      <span className="material-icons " id="indcti">
        
      <span className="material-icons " id="izk84l">
        
      </span>
      
      </span>
      
        <a
          target="_blank"
          className=""
          id="isdo4d"
          href=""
        >
          
      <span className="material-icons " id="i3c93a">
        <>call</>
      </span>
      
        </a>
        
        <a
          target="_blank"
          className=""
          id="igbhjj"
          href=""
        >
          
      <span className="material-icons " id="iu387l">
        <>mail</>
      </span>
      
        </a>
        
      </div>
      
      </div>
      
      </div>
      
      <div id="ihk8" className="">
      
      <div id="it6xg" className="">
      
      <div className="" id="ip3sl">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="i1p9rj">
        <>Terapia Healing Touch</>
      </span>
      
      </div>
      
      <div id="iwm6zf" className="">
      
      </div>
      
      <div className="" id="i803s">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="im5ewa">
        <>Toque sanado</>
      <br className="" id="" />
      
      </span>
      
      </div>
      
      </div>
      
      <div className="" id="ie17l6">
        
      <br className="" id="" />
      
      </div>
      
      </div>
      
      <div id="iidiwj" className="">
      
      <div
        id="ibbcyh"
        className=""
        data-aos="zoom-in-right"
        data-aos-duration="2000"
      >
      
      <div id="i92bow" className="">
      
      <div className="" id="ivskw4">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="i7am16">
        <>Definicion de Healing Touch</>
      </span>
      
      </div>
      
        <a
          target=""
          className=""
          id="iegd5z"
          href="#"
        >
          
      <div id="irh3ts" className="">
      <>SERVICIOS</>
      </div>
      
        </a>
        
      </div>
      
      </div>
      
      <div id="iwizbh" className="">
      
      <div id="iwhm7s" className="">
      
      <div className="" id="ih7w5f">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="it07e5">
        <>Es un método terapéutico que trabaja el campo bio energético de la persona, potenciando la auto-sanación del paciente en sus aspectos espirituales, mentales, emocionales y físicos </>
      </span>
      
      </div>
      
      <div id="i22w7h" className="">
      
      <img
        className=""
        id="ifffnj"
        src="https://assetsprojects.s3.amazonaws.com/404no3im4x5jdce.png"
        alt="undefined"
      />
      
      <div className="" id="ineufm">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="ibhj9p">
        <>Janet Mentgen</>
      </span>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="i7sy7d" className="">
      
      <div id="i9z7a6" className="">
      
      </div>
      
      <div className="" id="iz00lo">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="i4vuv5">
        <>Healing Touch es un método terapéutico de la medicina bioenergética desarrollado por Janet Mentgen (EE.UU), enfermera holística que, en el año 1988, fue honrada como la enfermera del año por la Asociación de Enfermeras Holísticas de América, por su valioso trabajo usando el Toque Sutil y Sanador de las manos en el cuidado de sus pacientes. </>
      </span>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="i3dh" className="">
      
      <div
        id="iz4858"
        className=""
        data-aos="zoom-in-left"
        data-aos-duration="2000"
      >
      
      <div id="ii8bxc" className="">
      
      <div className="" id="igqyi">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="iddqni">
        <>¿Cómo pueden ayudarte las terapias de Healing Touch?</>
      </span>
      
      </div>
      
        <a
          target=""
          className=""
          id="ikz02f"
          href="#"
        >
          
      <div id="ib4ek4" className="">
      <>VER MÁS</>
      </div>
      
        </a>
        
      </div>
      
      </div>
      
      <div id="ihp5j" className="">
      
      <div id="ivuade" className="">
      
      <div id="ik2cjx" className="">
      
      <div className="" id="ixvxyr">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="ijiawl">
        <>Limpia, Armoniza y Fortalece nuestro Campo Energético (Aura) y Centros de Energía (Chakras).</>
      </span>
      
      </div>
      
      </div>
      
      <div className="" id="ijtmyj">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="ingi2l">
        <>Fortalece el Sistema Inmunológico</>
      </span>
      
      </div>
      
      <div className="" id="iwdb69">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="i2s2wz">
        <>Reduce la Ansiedad, la Tensión, el Miedo y la Incertidumbre.</>
      </span>
      
      </div>
      
      <div className="" id="iq3cci">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="iab2cl">
        <>Alivia Dolores, tales como el Dolor de Espalda, de Cabeza, Musculares, etc.</>
      </span>
      
      </div>
      
      <div className="" id="ion5zl">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="ijcqcg">
        <>Fortalece la Recuperación después de Cirugías.</>
      </span>
      
      </div>
      
      <div className="" id="iq32gh">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="io6x8q">
        <>Asiste a Farmacodependientes, pacientes con Cáncer, Sida, Lupus, Neuropatías y otras enfermedades.</>
      </span>
      
      </div>
      
      </div>
      
      <img
        className=""
        id="iwh6b4"
        src="https://assetsprojects.s3.amazonaws.com/404no3im4x5x5gb.png"
        alt="undefined"
      />
      
      </div>
      
      </div>
      
      <div id="ilvug2" className="">
      
      <div id="iimy5q" className="">
      
      <img
        className=""
        id="iqa9ll"
        src="https://assetsprojects.s3.amazonaws.com/404ofwim68ajna6.jpg"
        alt="undefined"
      />
      
      <div id="is8212" className="">
      
      </div>
      
      <div id="ikpaqe" className="">
      
      <div className="" id="ivyfqf">
        <>SOBRE MI</>
      </div>
      
      <div className="" id="iiodad">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="ibr2vg">
        <>Hola Soy Claudia Tabora</>
      </span>
      
      </div>
      
      <div className="" id="ioutrr">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="idd6bu">
        <>Especializada en terapias energéticas y bienestar holístico. Mi misión es ayudarte a conectar con tu esencia, equilibrar tu energía , promover el bienestar físico y emocional.<br /></>
      </span>
      
      <span className="" id="ipj58z">
        <>He acompañado a personas en su camino hacia el bienestar físico, emocional y espiritual, utilizando herramientas como: Healing Touch, coaching de vida, dula del alma aplicada al duelo, programación neurolingüística y  sanergia aplicada a personas y animales.</>
      </span>
      
      </div>
      
      <div id="ikh54u" className="">
      
      <div className="" id="in5jbl">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="i8y6fk">
        <>Mi enfoque combina:</>
      </span>
      
      </div>
      
      <div id="i38gnk" className="">
      
      <div id="i04mj7" className="">
      
      </div>
      
      <div className="" id="icbpv2">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="ivictl">
        <>Terapias energéticas</>
      </span>
      
      </div>
      
      </div>
      
      <div id="inltlq" className="">
      
      <div id="ik04wv" className="">
      
      </div>
      
      <div className="" id="iywd0o">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="i4msnn">
        <>Conocimientos holisticos</>
      </span>
      
      </div>
      
      </div>
      
      <div id="igus7g" className="">
      
      <div id="iqr6cl" className="">
      
      </div>
      
      <div className="" id="ic5zjd">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="ij0zdt">
        <>Técnicas programacion neurolingustica</>
      </span>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="i1ptfo" className="">
      
      <img
        className=""
        id="i8ac69"
        src="https://assetsprojects.s3.amazonaws.com/404ofwim5vfzzb1.png"
        alt="undefined"
      />
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="i7qj2" className="">
      
      <div id="i25q0j" className="">
      
      </div>
      
      <div
        id="ia5j0d"
        className=""
        data-aos="zoom-in-up"
        data-aos-duration="2000"
      >
      
      <div id="ir9zyk" className="">
      
      <div className="" id="ivnuhr">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="irnaup">
        <>Comienza tu camino hacia tu bienestar</>
      </span>
      
      </div>
      
      <div className="" id="i5vija">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="ik5hof">
        <>Las terapias energéticas son tecnicas no invasivas que buscan armonizar el flujo energético de tu cuerpo. Sin efectos negativos.</>
      </span>
      
      </div>
      
      <div id="i3usi9" className="">
      
        <a
          target=""
          className=""
          id="inc6tg"
          href="#"
        >
          
      <div id="i0ff7g" className="">
      <>AGENDA UNA CITA</>
      </div>
      
        </a>
        
        <a
          target=""
          className=""
          id="i5ws9h"
          href="#"
        >
          
      <div id="ix445g" className="">
      <>CONTÁCTANOS</>
      </div>
      
        </a>
        
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="icohi" className="">
      
      <div id="iyghfd" className="">
      
      <div id="i52pnr" className="">
      
      <div className="" id="iyo7r6">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="i9f89n">
        <>Choloma, Cortes</>
      <br className="" id="" />
      <>Res. Bello Horizonte, Segunda etapa</>
      </span>
      
      </div>
      
      <div id="i3kbn4" className="">
      
        <a
          target="_blank"
          className=""
          id="ixsthl"
          href="#"
        >
          
      <img
        className=""
        id="iwpiyw"
        src="https://assetsprojects.s3.amazonaws.com/404no3im4x6jbbv.png"
        alt="undefined"
      />
      
        </a>
        
        <a
          target="_blank"
          className=""
          id="ikcig4"
          href="#"
        >
          
      <img
        className=""
        id="iv6mle"
        src="https://assetsprojects.s3.amazonaws.com/404no3im4x6jd5s.png"
        alt="undefined"
      />
      
        </a>
        
        <a
          target="_blank"
          className=""
          id="itq03p"
          href="#"
        >
          
      <img
        className=""
        id="isa627"
        src="https://assetsprojects.s3.amazonaws.com/404no3im4x6jfas.png"
        alt="undefined"
      />
      
        </a>
        
        <a
          target="_blank"
          className=""
          id="ig3kxb"
          href="#"
        >
          
      <img
        className=""
        id="iqlafz"
        src="https://assetsprojects.s3.amazonaws.com/404no3im4x6jgsb.png"
        alt="undefined"
      />
      
        </a>
        
      </div>
      
      </div>
      
      <img
        className=""
        id="ik3jqu"
        src="https://assetsprojects.s3.amazonaws.com/404ofwim5mu722a.png"
        alt="undefined"
      />
      
      </div>
      
      <div id="iou1pv" className="">
      
      <div id="i2vw8i" className="">
      
      </div>
      
      <div id="iabdji" className="">
      
      <div id="izci0t" className="">
      
      <div className="" id="izq2dp">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="iubk6b">
        <>Copyrigt © 2024 </>
      </span>
      
      </div>
      
      <div className="" id="i4zwph">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="ix41ho">
        <>Terapias Energéticas</>
      </span>
      
      </div>
      
      </div>
      
      <div id="ip8opa" className="">
      
      <div className="" id="in8zl9">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="iytx9d">
        <>Términos y condiciones</>
      </span>
      
      </div>
      
      <div className="" id="ivyeul">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="i5zx35">
        <>Políticas de privacidad</>
      </span>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
</div>
  );
}

const mapStateToProps = (state) => state.auth;

const mapDispatchToProps = (dispatch) => ({
 addLoftyTokenApp: (data) => dispatch(addLoftyToken(data)),
 deleteLoftytokenApp: () => dispatch(deleteLoftytoken()),
});


export default connect(mapStateToProps, mapDispatchToProps)(Phomepageterapiasenergticas15fz9);
  